const styles = {
    pageContainer: {
        width: "100%",
        px: 2,
        mt: 0,
    },
    loadingContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
    },
    headerSection: {
        backgroundColor: "#f5f5f5",
        p: 4,
        borderRadius: 2,
        mb: 2,
    },
    headerTitle: {
        fontWeight: 700,
        mb: 1,
        fontFamily: '"Plus Jakarta Sans", "Plus Jakarta Sans Fallback", Helvetica, Arial, sans-serif',
    },
    headerSubtitle: {
        color: "rgba(0, 0, 0, 0.6)",
        fontFamily: '"Plus Jakarta Sans", "Plus Jakarta Sans Fallback", Helvetica, Arial, sans-serif',
    },
    card: {
        borderRadius: 2,
        height: "100%",
    },
    cardContent: {
        p: 3,
    },
    cardTitle: {
        mb: 2,
        fontWeight: 600,
        fontFamily: '"Plus Jakarta Sans", "Plus Jakarta Sans Fallback", Helvetica, Arial, sans-serif',
    },
    divider: {
        mb: 3,
    },
    infoFieldLabel: {
        fontWeight: 500,
        fontFamily: '"Plus Jakarta Sans", "Plus Jakarta Sans Fallback", Helvetica, Arial, sans-serif',
    },
    infoFieldValue: {
        fontFamily: '"Plus Jakarta Sans", "Plus Jakarta Sans Fallback", Helvetica, Arial, sans-serif',
    },
    futureContent: {
        p: 3,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
    },
    futureContentText: {
        fontWeight: 500,
        fontFamily: '"Plus Jakarta Sans", "Plus Jakarta Sans Fallback", Helvetica, Arial, sans-serif',
    },
};

export default styles;
